import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const areas = ['Las Vegas', 'Henderson', 'North Las Vegas', 'Summerlin', 'Boulder City', 'Spring Valley', 'Enterprise', 'Paradise'];
export function ServiceArea() {
  return <section id="service-area" className="py-24 bg-[#2d2d2d] border-t border-[#3a3a3a]" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="flex flex-col md:flex-row items-center justify-between gap-16" data-id="element-131">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="md:w-1/2" data-id="element-132">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1f1f1f] border border-[#3a3a3a] text-sm font-bold text-[#FFD700] mb-6 uppercase tracking-wide" data-id="element-133">
              <MapPin className="w-4 h-4" data-id="element-134" />
              Service Area
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 uppercase" data-id="element-135">
              PROUDLY SERVING THE <br data-id="element-136" />
              LAS VEGAS VALLEY
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-137">
              We provide fast, reliable electrical services across Southern
              Nevada. Not sure if you're in our service area? Give us a call,
              and we'll let you know!
            </p>

            <div className="grid grid-cols-2 gap-y-4 gap-x-8" data-id="element-138">
              {areas.map((area, index) => <div key={index} className="flex items-center gap-3 text-gray-300 font-medium" data-id="element-139">
                  <div className="w-2 h-2 rounded-full bg-[#FFD700]" data-id="element-140" />
                  {area}
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="md:w-1/2 w-full" data-id="element-141">
            <div className="rounded-3xl overflow-hidden relative" data-id="element-142">
              <img src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=800&q=80" alt="Nevada desert highway landscape" className="w-full h-[400px] object-cover" data-id="element-143" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2d2d2d] via-[#2d2d2d]/30 to-transparent" data-id="element-144" />
              <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-145">
                <div className="flex items-center gap-3" data-id="element-146">
                  <div className="w-12 h-12 bg-[#FFD700] rounded-full flex items-center justify-center" data-id="element-147">
                    <MapPin className="w-6 h-6 text-[#1f1f1f]" data-id="element-148" />
                  </div>
                  <div data-id="element-149">
                    <div className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-150">
                      Southern Nevada
                    </div>
                    <div className="text-gray-300 text-sm" data-id="element-151">
                      Las Vegas Valley & Surrounding Areas
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}